import { useContext, useMemo } from "react";

import { DataContext } from "contexts/Data";

import type { Model } from "types/app";

/**
 * Only use this hook under DataContext
 */
export default function useModel(): Model {
  const { cachedState } = useContext(DataContext);

  return useMemo(() => {
    return cachedState.model;
  }, [cachedState.model]);
}
